import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "./css/Header.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Asegúrate de importar bootstrap.bundle.min.js

const Header = (props) => {
  const [navLinks, setNavLinks] = useState([
    { to: "/", label: "Home" },
  ]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const { userPermissions } = props;
    const loggedIn = userPermissions?.isLoggedIn || false;
    const showPerMenu = userPermissions?.per || false;

    let links = [{ to: "/", label: "Home" }];

    if (showPerMenu) {
      links = [
        ...links,
        { to: "/preguntas_per", label: "Preguntas PER" },
        { to: "/estadisticas_per", label: "Estadísticas PER" },
      ];
    }

    if (!loggedIn) {
      links = [
        ...links,
        { to: "/login", label: "Login" },
        { to: "/contacto", label: "Contacto" },
      ];
    } else {
      links = [
        ...links,
        { to: "/contacto", label: "Contacto" },
      ];
    }

    setNavLinks(links);
    setIsLoggedIn(loggedIn);
  }, [props.userPermissions]);

  const handleLogout = () => {
    const defaultPermissions = {
      isLoggedIn: false,
      per: false,
      ai: false,
      acestream: false,
    };

    localStorage.setItem("userPermissions", JSON.stringify(defaultPermissions));
    window.location.href = "/";
  };

  return (
    <header>
      <div className="container">
        <div className="row">
          <div className="col-12 sub-header clearfix d-flex flex-column flex-md-row align-items-center justify-content-between">
            {/* Letrero */}
            <h1 className="col-12 col-md-4 d-flex justify-content-center">
              <NavLink to="/">
                <div className="d-flex align-items-center">
                  <h2 className="letrero">aje</h2>
                  <h2 className="letrero2">sl</h2>
                </div>
              </NavLink>
            </h1>

            {/* Barra de navegación con menú hamburguesa */}
            <div className="col-12 col-md-8 centrar">
              <nav className="navbar navbar-expand-lg navbar-light justify-content-center align-items-center">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav">
                    {navLinks.map((link, index) => (
                      <li key={index} className="nav-item">
                        <NavLink
                          to={link.to}
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                          end
                        >
                          {link.label}
                        </NavLink>
                      </li>
                    ))}
                    {isLoggedIn && (
                      <li className="nav-item">
                        <NavLink
                          to="/logout"
                          className={({ isActive }) =>
                            isActive ? "active nav-link" : "nav-link"
                          }
                          onClick={handleLogout}
                        >
                          Cerrar Sesión
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div className="linea"></div>
      </div>
    </header>
  );
};

export default Header;
